// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0acfd276","703":"aaf70c6b"}[chunkId] + ".chunk.js";
};